/**
 * CONFIRMATION PAR RECOPIE D'UN MOT — la comparaison, partagée par les fenêtres qui
 * demandent un geste irréversible (réinitialisation d'une bibliothèque, suppression d'un
 * dossier).
 *
 * ⚠ CONTRAINTE UTILISATEUR RÉELLE, et c'est toute la raison d'être de ce module : sur un
 * clavier suisse, taper une MAJUSCULE ACCENTUÉE est malaisé. Deux règles en découlent,
 * indissociables :
 *
 *  1. le mot AFFICHÉ par chaque catalogue i18n est écrit SANS accent
 *     (« REINITIALISER », « ZURUCKSETZEN », « SUPPRIMER », « LOSCHEN ») ;
 *  2. la comparaison NORMALISE les deux côtés — décomposition NFD puis retrait des
 *     diacritiques, `trim`, majuscules — pour que « löschen », « LÖSCHEN » et
 *     « LOSCHEN » soient acceptés indifféremment.
 *
 * La règle 2 sans la règle 1 laisserait l'utilisateur devant un mot qu'il ne peut pas
 * taper ; la règle 1 sans la règle 2 refuserait la saisie de qui a un clavier normal.
 */

/** Forme comparable d'une saisie : sans diacritique, sans espaces de bord, en majuscules. */
function normalizeConfirmWord(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim()
    .toUpperCase();
}

/** La saisie correspond-elle au mot de confirmation attendu ? PURE. */
export function confirmWordMatches(typed: string, expected: string): boolean {
  return normalizeConfirmWord(typed) === normalizeConfirmWord(expected);
}
